import React from 'react';
import { StatusBadge } from '../../../../components/StatusBadge/StatusBadge';

const COUPON_STATUS_BADGES = {
  active: { label: 'Ativo', variant: 'success' },
  paused: { label: 'Pausado', variant: 'warning' },
  expired: { label: 'Expirado', variant: 'danger' },
};

export function getCouponStatus(coupon) {
  if (!coupon?.active) return 'paused';
  if (coupon?.expiresAt && new Date(coupon.expiresAt) < new Date())
    return 'expired';
  return 'active';
}

export function CouponStatusBadge({ coupon }) {
  const badge = COUPON_STATUS_BADGES[getCouponStatus(coupon)];

  return <StatusBadge label={badge.label} variant={badge.variant} />;
}
